import { extendTheme } from '@chakra-ui/react';

import { theme } from '../../theme';

export default extendTheme(theme);
